import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const VaServicesWeOffer = () => {
  const [vaServices, setVaServices] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/./VaServices.json`)
      .then((response) => response.json())
      .then((data) => setVaServices(data))
      .catch((error) => console.error("Error fetching va services:", error));
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="slider">
      <Slider {...settings}>
        {vaServices.map((vaservice, index) => (
          <div className="va-card-container">
            <img
              src={vaservice.icon}
              alt={`Service Icon ${index + 1}`}
              style={{ objectFit: "cover" }}
              className="hexagon-image"
            />
            <h4>{vaservice.title}</h4>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default VaServicesWeOffer;
